import React from 'react';
import { Text, TextInput } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { 
    Add as AddIcon, 
    Remove as RemoveIcon 
} from '@mui/icons-material';

/**
 *
 * @param {*} props
 */
export default function Efap({ classes, expanded, efap, handleChange, theme, accessCode }) {
    const styles = {
        kiiRow: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            marginBottom: 5
        },
        column: {
            display: 'flex',
            flexDirection: 'column'
        }
    };

    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('efap')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('efap') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>Employee Assistance Program</Text>
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    {
                        efap.isEligible === 1 ?
                            <React.Fragment>
                                {
                                    efap.carrier?.toUpperCase() === 'KII' &&
                                    <div style={ styles.column }>
                                        <div style={{ marginBottom: 10}}>
                                            {
                                                efap.includeEmployeeAssistance ?
                                                    <>
                                                        <Text small bold margin="20px 0px 10px 0px">
                                                            Welcome to Kii, a program designed to empower you to live your best life. Get confidential, immediate support for any health, work or life challenges you may be facing.
                                                        </Text>
                                                        <Text small bold margin="0px 0px 10px 0px">
                                                            Your membership includes;
                                                        </Text>

                                                        <div style={ styles.kiiRow}>
                                                            <Text small margin='0px 10px 0px 0px'>
                                                                •
                                                            </Text>
                                                            <Text small>
                                                                Employee and Family Assistance Program (EFAP) = Speak to an advisor for work-related issues, legal or financial help and support with home and family matters.
                                                            </Text>
                                                        </div>

                                                        <div style={ styles.kiiRow}>
                                                            <Text small margin='0px 10px 0px 0px'>
                                                                •
                                                            </Text>
                                                            <Text small>
                                                                Mental Health & Wellness = Access to licensed therapists, no matter the intensity of your challenges. From prevention of to treatment for conditions such as depression, anxiety, stress, grief, trauma and more.
                                                            </Text>
                                                        </div>

                                                        <div style={ styles.kiiRow}>
                                                            <Text small margin='0px 10px 0px 0px'>
                                                                •
                                                            </Text>
                                                            <Text small>
                                                                Reference Library = Access credible health information to learn more about your conditions and treatment plans. Featuring over 90+ health associations and the Mayo Clinic.
                                                            </Text>
                                                        </div>

                                                        <div style={ styles.kiiRow}>
                                                            <Text small margin='0px 10px 0px 0px'>
                                                                •
                                                            </Text>
                                                            <Text small>
                                                                Health & Wellness eNewsletters and Webinars = All members who sign up for Kii online will receive monthly articles, videos and invites to live webinars.
                                                            </Text>
                                                        </div>
                                                        <Text small bold margin="10px 0px 10px 0px">
                                                            There is no cost to you or your family to use Kii. This program has been provided to you by your employer. If you need more specialized support that isn’t covered by the program, your nurse can suggest an appropriate care plan and help you navigate coverage via other benefits and/or the public health care system.
                                                        </Text>
                                                    </>
                                                    : null
                                            }
                                        
                                            {
                                                efap.includeEldercare ?
                                                    <a href="https://d6hvupc5g7lnm.cloudfront.net/files/Kii_Eldercare_En.pdf" style={{ textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">
                                                        <Text small bold margin="5px 0px 0px 0px" customStyle={{ textDecoration: 'underline' }}>
                                                            Eldercare Benefits Included
                                                        </Text>
                                                    </a>
                                                    : null
                                            }

                                            {
                                                efap.includeMedicalSecondOpinion ?
                                                    <a href="https://d6hvupc5g7lnm.cloudfront.net/files/Kii_Medical_Second_Opinion_En.pdf" style={{ textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">
                                                        <Text small bold margin="5px 0px 0px 0px" customStyle={{ textDecoration: 'underline' }}>
                                                            Medical Second Opinion Benefits Included
                                                        </Text>
                                                    </a>
                                                    : null
                                            }

                                            {
                                                efap.includeMentalHealthOnDemand ?
                                                    <Text small bold margin="5px 0px 0px 0px">
                                                        Mental Health On Demand Included
                                                    </Text>
                                                    : null
                                            }
                                         </div>

                                        {
                                            efap.includeEmployeeAssistance ?
                                                <>
                                                    <Text
                                                        small
                                                         margin="5px 0px 0px 0px"
                                                    >
                                                        Phone Number: <Text small customStyle={{ textDecoration: 'underline', display: 'inline' }}>1-866-814-0018</Text> 
                                                    </Text>

                                                    <a href="https://secure.kiihealth.ca/register?eac=&lang=en" style={{ textDecoration: 'none', textDecoration: 'underline' }} target="_blank" rel="noopener noreferrer">
                                                        <Text
                                                            small
                                                            display="block"
                                                             margin="5px 0px 0px 0px"
                                                        >
                                                            Register with Kii
                                                        </Text>
                                                    </a>
                                                </>
                                                : null
                                        }
                                    </div>
                                }

                                {
                                    efap.carrier?.toUpperCase() === 'ADVICA' &&
                                    <div style={ styles.column }>
                                        <Text small bold margin="20px 0px 10px 0px">
                                            You are enrolled in the completely confidential Employee and Family Assistance Program (Advica). See the links below for details.
                                        </Text>

                                        {
                                            efap.includeEldercare ?
                                                <Text small bold margin="5px 0px 0px 0px">Eldercare Benefits Included</Text>
                                                : null
                                        }

                                        {
                                            efap.includeMedicalSecondOpinion ?
                                                <Text small bold margin="5px 0px 0px 0px">Medical Second Opinion Benefits Included</Text>
                                                : null
                                        }

                                        {
                                            efap.includeMentalHealthOnDemand ?
                                                <Text small bold margin="5px 0px 0px 0px">Mental Health On Demand Included</Text>
                                                : null
                                        }

                                        {
                                           efap.includeEmployeeAssistance ?
                                           <>
                                                <a href="https://d6hvupc5g7lnm.cloudfront.net/files/AdvicaEfapGuide.pdf" download="EFAP Guide.pdf" style={{ textDecoration: 'none', marginTop: 10 }} target="_blank" rel="noopener noreferrer">
                                                    <Text
                                                        color={theme.colors.skyBlue}
                                                        small
                                                        display="block"
                                                    >
                                                        EFAP Guide
                                                    </Text>
                                                </a>

                                                <a href="https://advicahealth.com/simplybenefitsemployeeplan" style={{ textDecoration: 'none'}} target="_blank" rel="noopener noreferrer">
                                                    <Text
                                                        color={theme.colors.skyBlue}
                                                        small
                                                        display="block"
                                                    >
                                                        Learn more about the Employee and Family Assistance Program
                                                    </Text>
                                                </a>
                                           </>
                                           : null
                                        }
                                        

                                        {
                                            efap.includeMentalHealthOnDemand ?
                                            <a href="https://advicahealth.com/simplybenefitsementalhealth" style={{ textDecoration: 'none'}} target="_blank" rel="noopener noreferrer">
                                                <Text
                                                    color={theme.colors.skyBlue}
                                                    small
                                                    display="block"
                                                >
                                                    Learn more about the Mental Health on Demand Program
                                                </Text>
                                            </a>
                                            : null
                                        }

                                        <a href="" style={{ textDecoration: 'none'}} target="_blank" rel="noopener noreferrer">
                                            <Text
                                                color={theme.colors.skyBlue}
                                                small
                                                bold
                                            >
                                                Call Advica:
                                            </Text>
                                        </a>
                                </div>
                                }

                                {
                                    efap.carrier?.toUpperCase() === 'DIALOGUE' &&
                                    <div style={ styles.column }>
                                        <Text small bold margin="20px 0px 10px 0px">
                                            You are enrolled in the completely confidential Employee and Family Assistance Program with Dialogue.
                                        </Text>

                                        {
                                            efap.includeEldercare ?
                                                <Text small bold margin="5px 0px 0px 0px">Eldercare Benefits Included</Text>
                                                : null
                                        }

                                        {
                                            efap.includeMedicalSecondOpinion ?
                                                <Text small bold margin="5px 0px 0px 0px">Medical Second Opinion Benefits Included</Text>
                                                : null
                                        }

                                        {
                                            efap.includeMentalHealthOnDemand ?
                                                <Text small bold margin="5px 0px 0px 0px">Mental Health On Demand Included</Text>
                                                : null
                                        }


                                        <Text small bold margin="15px 0px 10px 0px">
                                            {`Dialogue’s EFAP will give you access to essential wellness services to stay happy and healthy:`}
                                        </Text>

                                        <ul style={{ listStyle: 'disc', paddingLeft: '16px', marginLeft: '1px' }}>
                                            <li><Text small margin="0px 0px 0px 0px">Mental Health: Mood disorders (depression, anxiety, etc.), insomnia and fatigue, stress, anger and emotion regulation, grief. etc.</Text></li>
                                            <li><Text small margin="5px 0px 0px 0px">Family and Relationships: Parenting, relationship and intimacy, family dynamics, conflict resolution, etc. </Text></li>
                                            <li><Text small margin="5px 0px 0px 0px">Work and Career: Professional development, work performance, workplace conflict, etc.</Text></li>
                                            <li><Text small margin="5px 0px 0px 0px">Legal Services: Civil and criminal law (consumer protection, contracts), property law (commercial, residentials), etc.</Text></li>
                                            <li><Text small margin="5px 0px 0px 0px">Financial Services: Bankruptcy, debt, real estate, mortgage, retirement planning, etc.</Text></li>
                                        </ul>

                                        <Text small margin="10px 0px 0px 0px">
                                            <a href="https://pages-support.dialogue.co/eap-signup/" target="_blank" rel="noopener noreferrer">Learn more about the Employee and Family Assistance Program</a>
                                        </Text>
                                    </div> 
                                }

                                {
                                    accessCode ?
                                        <Text
                                            small
                                            margin="10px 0px 0px 0px"
                                        >
                                            Access Code: { accessCode }
                                        </Text>
                                        : null
                                }
                            </React.Fragment>
                            :
                            <div className={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                You are currently ineligible for this benefit, if this is a mistake please contact your administrator.
                                </Text>
                            </div>
                    }
                </AccordionDetails>
            </Accordion>
        </div>
    );
}